/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mock_Church_NameInputs */

const en_mock_church_name = /** @type {(inputs: Mock_Church_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sanctuary Hub`)
};

const es_mock_church_name = /** @type {(inputs: Mock_Church_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hub del Santuario`)
};

const fr_mock_church_name = /** @type {(inputs: Mock_Church_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hub du Sanctuaire`)
};

const de_mock_church_name = /** @type {(inputs: Mock_Church_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sanctuary Hub`)
};

const id_mock_church_name = /** @type {(inputs: Mock_Church_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hub Tempat Ibadah`)
};

/** @type {(inputs: Mock_Church_NameInputs) => LocalizedString} */
const ja_mock_church_name = en_mock_church_name;

/** @type {(inputs: Mock_Church_NameInputs) => LocalizedString} */
const zh_mock_church_name = en_mock_church_name;

/** @type {(inputs: Mock_Church_NameInputs) => LocalizedString} */
const ar_mock_church_name = en_mock_church_name;

/** @type {(inputs: Mock_Church_NameInputs) => LocalizedString} */
const it_mock_church_name = en_mock_church_name;

/** @type {(inputs: Mock_Church_NameInputs) => LocalizedString} */
const ru_mock_church_name = en_mock_church_name;

/** @type {(inputs: Mock_Church_NameInputs) => LocalizedString} */
const pt_mock_church_name = en_mock_church_name;

/** @type {(inputs: Mock_Church_NameInputs) => LocalizedString} */
const ko_mock_church_name = en_mock_church_name;

/**
* | output |
* | --- |
* | "Sanctuary Hub" |
*
* @param {Mock_Church_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const mock_church_name = /** @type {((inputs?: Mock_Church_NameInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mock_Church_NameInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mock_church_name(inputs)
	if (locale === "es") return es_mock_church_name(inputs)
	if (locale === "fr") return fr_mock_church_name(inputs)
	if (locale === "de") return de_mock_church_name(inputs)
	if (locale === "ja") return ja_mock_church_name(inputs)
	if (locale === "zh") return zh_mock_church_name(inputs)
	if (locale === "ar") return ar_mock_church_name(inputs)
	if (locale === "id") return id_mock_church_name(inputs)
	if (locale === "it") return it_mock_church_name(inputs)
	if (locale === "ru") return ru_mock_church_name(inputs)
	if (locale === "pt") return pt_mock_church_name(inputs)
	return ko_mock_church_name(inputs)
});